import React, { useEffect, useMemo, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Menu } from '@doxyme/ui';
import { noop } from 'lodash';
import { TroubleshootingWizardHeader } from '../TroubleshootingWizardHeader';
import { TroubleshootingWizardInfo } from '../TroubleshootingWizardInfo';
import { TroubleshootingWizardActions } from '../TroubleshootingWizardActions';
import { useSelector, useDispatch } from 'react-redux';
import * as helpers from '../../helpers';
import * as selectors from '../../selectors';
import * as actions from '../../actions';
import './TroubleshootingWizard.scss';
const TITLE_ID = 'troubleshooting-wizard-title';
const DESCRIPTION_ID = 'troubleshooting-wizard-description';
export const TroubleshootingWizard = ({ onClose = noop, isPatient, }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const dialogRef = useRef(null);
    const currentStepName = useSelector(selectors.getStepName);
    const flow = useMemo(() => helpers.getTroubleshootingFlow(isPatient), [isPatient]);
    const currentStep = flow[currentStepName];
    const close = () => {
        onClose();
        dispatch(actions.setStepName(null));
    };
    useEffect(() => {
        // No early-return guard for `!currentStep` is needed: when it's absent
        // the component renders null, so `dialogRef.current` is null and the
        // optional-chained `focus()` is a no-op.
        const id = window.setTimeout(() => dialogRef.current?.focus(), 0);
        return () => window.clearTimeout(id);
    }, [currentStepName, currentStep]);
    const onKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            close();
        }
    };
    if (!currentStep)
        return null;
    return (<div ref={dialogRef} role="alertdialog" aria-labelledby={TITLE_ID} aria-describedby={DESCRIPTION_ID} tabIndex={-1} onKeyDown={onKeyDown} className="troubleshooting-wizard-dialog">
      <Menu className="troubleshooting-wizard">
        <TroubleshootingWizardHeader title={intl.formatMessage({ id: 'troubleshooting.wizard.title' })} titleId={TITLE_ID} onClose={close}/>
        <TroubleshootingWizardInfo id={DESCRIPTION_ID} items={currentStep.textItems}/>
        <TroubleshootingWizardActions actions={currentStep.actions}/>
      </Menu>
    </div>);
};
